import React from 'react';
import { CHART_TYPES } from 'features/dashboards/chartTypes';

/** Chart types as tiles: pick one by its shape. */
export default function ChartTypePicker({ value, onChange }) {
  return (
    <div role="radiogroup" aria-label="Chart type" className="grid grid-cols-4 gap-1.5">
      {CHART_TYPES.map(({ id, label, icon: Icon, needs }) => {
        const on = (value || '') === id;
        return (
          <button key={id || 'auto'} type="button" role="radio" aria-checked={on} onClick={() => onChange(id)}
            title={needs ? `${label} — needs ${needs}` : label}
            className={`flex flex-col items-center gap-1 rounded-md border px-1 py-2 text-[11px] transition-colors ${on
              ? 'border-[color:var(--brand-primary)] bg-[color:color-mix(in_srgb,var(--brand-primary)_10%,transparent)] text-[color:var(--text-primary)]'
              : 'border-[color:var(--border-default)] text-[color:var(--text-muted)] hover:bg-surface-hover hover:text-[color:var(--text-primary)]'}`}>
            <Icon className="h-4 w-4" strokeWidth={1.7} aria-hidden />
            <span className="w-full truncate text-center">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
